var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"spinner",attrs:{"width":_vm.size,"height":_vm.size,"viewBox":`0 0 ${_vm.size} ${_vm.size}`}},[_c('circle',{staticClass:"path",style:({'--diameter': 2 * _vm.radius}),attrs:{"cx":"50%","cy":"50%","r":_vm.radius,"stroke-width":_vm.width}})])
}
var staticRenderFns = []

export { render, staticRenderFns }